module.exports = __webpack_public_path__ + "images/emoji/relaxed.be420851d2828f2fd6ac.png";